import { Component, ElementRef, ViewChild } from "@angular/core";
import { IAfterGuiAttachedParams, ICellEditorParams } from "ag-grid";
import { ICellEditorAngularComp } from "ag-grid-angular";

declare var $:any;


@Component({
  selector: 'ag-date-picker-editor',
  template: `<input type="text" #datePickerInput (keydown)="onKeyDown($event)">`,
})
export class AgDatePickerEditor implements ICellEditorAngularComp {
	params: ICellEditorParams;
	datePicker;
	isChange: boolean = false;

	@ViewChild('datePickerInput')
	datePickerInput: ElementRef;

	getValue() {
		return this.datePickerInput.nativeElement.value;
	}
	
	isPopup?(): boolean {
		return false;
	}

	isCancelBeforeStart?(): boolean {
		return false;
	}

	isCancelAfterEnd?(): boolean {
		return !this.isChange && !this.datePickerInput.nativeElement.value;
	}

	// focusIn?(): void {
	// }

	// focusOut?(): void {
	// }

	agInit(params: ICellEditorParams): void {
		this.params = params;
		let jqObj = $(this.datePickerInput.nativeElement);
		this.datePicker = jqObj.datepicker({ dateFormat: "yymmdd" })
								.on( "change", () => {
									this.isChange = true;
									this.params.stopEditing();
								});
	}

	
	afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
		this.datePickerInput.nativeElement.focus();
		this.datePickerInput.nativeElement.select();
		if (this.params.charPress) this.datePickerInput.nativeElement.value = this.params.charPress;
	}


	onKeyDown(event: KeyboardEvent) {
		// 방향키
		if (event.keyCode >= 37 && event.keyCode <= 40) this.datePicker.datepicker('hide');
	}



}




// WEBPACK FOOTER //
// ./src/app/components/ag-grid/editor/ag-date-picker.editor.ts